var React = require('react');

function IconAiSparkle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 2.5l1.9 5.6 5.6 1.9-5.6 1.9L10 17.5l-1.9-5.6L2.5 10l5.6-1.9z","fill":"#000","key":0}),React.createElement("path",{"d":"M18.5 13.5l.95 2.55 2.55.95-2.55.95-.95 2.55-.95-2.55L15 17l2.55-.95z","fill":"#000","key":1})]);
}

IconAiSparkle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconAiSparkle;

IconAiSparkle.default = IconAiSparkle;
